import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AuthPage from "../pages/auth/page";
import VerifyEmailPage from "../pages/auth/VerifyEmailPage";
import PlansPage from "../pages/plans/page";
import { CheckoutPage } from "../pages/checkout/page";
import { CheckoutPaymentPage } from "../pages/checkout/payment";
import { CheckoutSuccessPage } from "../pages/checkout/success";
import { CheckoutErrorPage } from "../pages/checkout/error";
import { SubscriptionDashboardPage } from "../pages/subscription/page";
import LibraryPage from "../pages/library/page";
import CollabPage from "../pages/collab/page";
import TeamsPage from "../pages/teams/page";
import JoinTeamPage from "../pages/teams/JoinTeamPage";
import EventsPage from "../pages/events/page";
import SchedulePage from "../pages/schedule/page";
import PreferencesPage from "../pages/preferences/page";
import ProtectedRoute from "./ProtectedRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/auth/verify-email",
    element: <VerifyEmailPage />,
  },
  {
    path: "/plans",
    element: <PlansPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/checkout/payment",
    element: <ProtectedRoute><CheckoutPaymentPage /></ProtectedRoute>,
  },
  {
    path: "/checkout/success",
    element: <ProtectedRoute><CheckoutSuccessPage /></ProtectedRoute>,
  },
  {
    path: "/checkout/error",
    element: <ProtectedRoute><CheckoutErrorPage /></ProtectedRoute>,
  },
  {
    path: "/subscription-dashboard",
    element: <ProtectedRoute><SubscriptionDashboardPage /></ProtectedRoute>,
  },
  {
    path: "/library",
    element: <ProtectedRoute><LibraryPage /></ProtectedRoute>,
  },
  {
    path: "/collab",
    element: <ProtectedRoute><CollabPage /></ProtectedRoute>,
  },
  {
    path: "/teams",
    element: <ProtectedRoute><TeamsPage /></ProtectedRoute>,
  },
  {
    path: "/teams/join/:code",
    element: <ProtectedRoute><JoinTeamPage /></ProtectedRoute>,
  },
  {
    path: "/events",
    element: <ProtectedRoute><EventsPage /></ProtectedRoute>,
  },
  {
    path: "/schedule",
    element: <ProtectedRoute><SchedulePage /></ProtectedRoute>,
  },
  {
    path: "/preferences",
    element: <ProtectedRoute><PreferencesPage /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
